import { config } from '@static/js/env.config';
import { getDeviceResolution } from './deviceResolution';
import { getNodeEnv } from './getEnvironmentVariables';
const { isDevelopment } = getNodeEnv();

const PUBLIC_ASSETS_FOLDER = `https://withjoy.com/assets/public`;

// CDN base for self-hosted Google Fonts mirrored to S3. Published by scripts/font-mirror/.
export const SELF_HOSTED_FONTS_BASE = `${PUBLIC_ASSETS_FOLDER}/fonts/google`;

const assetScale = {
  1: '',
  2: '@2x',
  3: '@3x',
} as const;

const DEVICE_RESOLUTION = getDeviceResolution() as keyof typeof assetScale;

const ASSET_SCALE: string = assetScale[DEVICE_RESOLUTION] || assetScale[1];
export const TIMESTAMP_PARAM = new Date().toISOString().split('T')[0];

export const URLS = {
  graphicAccent: (accentId: string, scale?: 1 | 2 | 3) => {
    let affix: string = ASSET_SCALE;
    if (scale) {
      affix = assetScale[scale];
    }
    return `${PUBLIC_ASSETS_FOLDER}/graphicAccents/accent_${accentId}${affix}.png`;
  },
  masthead: (slug: string) => `${PUBLIC_ASSETS_FOLDER}/mastheads/${slug}.png`,
  styleApplicatorLib: `${isDevelopment ? config.clientUri + '/assets' : PUBLIC_ASSETS_FOLDER}/styles/applicator.js?ts=${TIMESTAMP_PARAM}`,
  webfontLib: 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js',
  walletButton: (platform: 'apple' | 'google', lang: string) => `${PUBLIC_ASSETS_FOLDER}/wallet-buttons/${platform}/${lang}.svg`,
  // Neutral Joy badge composited into the center of the Share-album QR code. `?format=png`
  // is required because the QR-generation backend fetches this server-side and can't decode
  // the CDN's default WebP (it returns 400 "Unable to generate QR code").
  qrBadge: `${PUBLIC_ASSETS_FOLDER}/joy-qr-badge-square-v2.png?format=png`,
} as const;

export const DOMAIN_NAME = 'withjoy.com/';
